<template>
  <Modal
    :title="title"
    :open="open"
    @update:open="$emit('update:open', $event)"
  >
    <div class="c-content u-mbl">
      {{ releaseNotes }}
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Modal from '@/components/Modal.vue'
import { useI18n } from '@/utils/i18n'

const props = defineProps<{
  releaseNotes: string
  open: boolean
  releaseName?: string
}>()

defineEmits<{
  (e: 'update:open', val: boolean): void
}>()

const { t } = useI18n({
  messages: {
    en: {
      releaseNotes: 'Release notes'
    },
    fr: {
      releaseNotes: 'Notes de release'
    }
  }
})

const title = computed(() => {
  if (!props.releaseName) {
    return t('releaseNotes')
  }
  return `${t('releaseNotes')} (${props.releaseName})`
})
</script>

<style scoped>
.c-content {
  white-space: pre-wrap;
}
</style>
